<template>
    <h2 class="section-title">
        <span>
            <slot />
        </span>
    </h2>
</template>

<script>
// Centred section heading with a rule on each side; replaces the 3-column divider rows
export default {
    name: 'SectionTitle'
}
</script>

<style scoped>
.section-title {
    display: flex;
    align-items: center;
    gap: 24px;
    width: 100%;
    margin: 0;
    color: #1b2f5a;
    font-size: clamp(26px, 3.6vw, 40px);
    font-weight: 700;
    line-height: 1.2;
    text-align: center;
}

.section-title::before,
.section-title::after {
    content: '';
    flex: 1;
    height: 2px;
    background: linear-gradient(90deg, rgba(27, 47, 90, 0) 0%, rgba(27, 47, 90, 0.35) 100%);
}

.section-title::after {
    background: linear-gradient(90deg, rgba(27, 47, 90, 0.35) 0%, rgba(27, 47, 90, 0) 100%);
}

.section-title span {
    flex: 0 1 auto;
}

@media (max-width: 599px) {
    .section-title {
        gap: 14px;
    }
}
</style>
